/**
 * The model of an analytics event
 */
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface AnalyticsProperties {}

export enum ActionType {
  Track = 'TRACK', // what are they doing ?
  View = 'VIEW', // what do they view ?
  Internal = 'INTERNAL', // what our software is doing?
}

export interface AnalyticsObject {
  name: string
  properties: AnalyticsProperties
}

export interface AnalyticsAction {
  name: string
  type?: ActionType
  properties?: AnalyticsProperties
}

export type AnalyticsEvent = {
  object: AnalyticsObject
  action: AnalyticsAction
  origin?: string
}
